
import React from 'react';
import { useTranslation } from '../../i18n';
import { GLOSSARY_TERMS } from '../../constants/glossary';

export const GlossaryModal = ({ open, onClose }) => {
  const { t } = useTranslation();

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-xl shadow-lg p-6 max-w-lg w-full max-h-[80vh] overflow-y-auto space-y-4"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-center sticky top-0 bg-white pb-2">
          <h3 className="text-lg font-semibold">{t('glossary.title')}</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">✕</button>
        </div>

        <div className="space-y-4">
          {GLOSSARY_TERMS.map((term) => (
            <div key={term.key} id={`glossary-${term.key}`} className="border-b pb-3 last:border-0">
              <div className="font-medium text-sm mb-1">{t(term.titleKey)}</div>
              <div className="text-sm text-gray-600">{t(term.bodyKey)}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};